import { useEffect, useState } from 'react';

/** Реактивный matchMedia. Для условного РЕНДЕРА вместо CSS-hidden: скрытый
 *  через `hidden`-класс компонент всё равно монтируется и работает (WS-хендлеры,
 *  таймеры, canvas) — так MobileTerminal со вторым графиком и стаканом жёг CPU
 *  на десктопе вхолостую. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
